module.exports = __webpack_public_path__ + "img/player_win.2d3c861c.png";